// const COUNTRY_SITES = {
//   ES: 'https://indiandcold.com/',
//   PT: 'https://indiandcold.com/pt-pt',
//   FR: 'https://indiandcold.com/fr-fr',
// };
const COUNTRY_SITES = {
  ES: 'https://indiandcold.myshopify.com/',
  PT: 'https://indiandcold.myshopify.com/pt-pt',
  FR: 'https://indiandcold.myshopify.com/fr-fr',
};
const WORLD_SHOP = 'worldindiandcold.myshopify.com';

function redirectToCountrySite() {
  if (!Object.keys(COUNTRY_SITES).includes(Shopify.country)) {
    return;
  }
  document.cookie = 'localization=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  window.location.href = COUNTRY_SITES[Shopify.country];
}

function isPageInIframe() {
  return (window.location !== window.parent.location);
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.href.indexOf('?ge-redirection') !== -1 || isPageInIframe() || window.location.href.indexOf('&preview_theme_id=') !== -1 || Shopify.shop !== WORLD_SHOP) {
    return;
  }
  const observer = new MutationObserver(() => {
    if (!Object.keys(COUNTRY_SITES).includes(Shopify.country)) {
      return;
    }
    redirectToCountrySite();
    observer.disconnect();
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
});

if (window.location.href.indexOf('?ge-redirection') === -1 && !isPageInIframe() && window.location.href.indexOf('&preview_theme_id=') === -1 && Shopify.shop === WORLD_SHOP) {
  redirectToCountrySite();
}
